"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "attendeeCameraStatusChanged", {
  enumerable: true,
  get: function get() {
    return _attendeeCameraStatusChanged["default"];
  }
});
var _attendeeCameraStatusChanged = _interopRequireDefault(require("./attendeeCameraStatusChanged"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }